module.exports = __webpack_public_path__ + "static/media/gt.1274b415.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/gt.svg
// module id = 136
// module chunks = 0